import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { IonIcon } from '@ionic/react';
import VnButton from '@ui/components/VnButton';
import '@ui/styles/table-style.css';
import { arrowDown, arrowUp, funnelOutline } from 'ionicons/icons';
import React, { useEffect } from 'react';
import { useState } from 'react';
import { useTable } from 'react-table';
import Select from 'react-select';
import { gridHeaderDropdownStyle } from '@ui/styles/grid-header-dropdown-style';
import '../../../styles/custom-table-style.css';
import { handleRolePermission } from '@infrastructure/helpers';
import { Permission, PermissionType } from '@application/common/enums/role-permission';
const InternalCreditureTable = ({ creditures, onRowClick, onSorting, onFilter, defaultSortingCriteria, onPreferenceToggleUpdate }) => {
    const creditorPrefernceDropdown = [
        {
            label: 'Ja',
            value: true
        },
        {
            label: 'Nee',
            value: false
        }
    ];
    const creditorExpiredDropdown = [
        {
            label: 'Ja',
            value: true
        },
        {
            label: 'Nee',
            value: false
        }
    ];
    const [sortingCriteria, setSortingCriteria] = useState(null);
    const [showFilters, setShowFilters] = useState(false);
    const [filterValues, setFilterValues] = useState({});
    const columns = React.useMemo(() => [
        { Header: 'Crediternr', accessor: 'creditorNumber' },
        { Header: 'Voorkeur', accessor: 'preference' },
        { Header: 'Naam', accessor: 'name' },
        { Header: 'Trefwoorden', accessor: 'keywords' },
        { Header: 'Adres', accessor: 'address' },
        { Header: 'Postcode', accessor: 'postalCode' },
        { Header: 'Plaats', accessor: 'city' },
        { Header: 'Telefoonnummer', accessor: 'phoneNumber' },
        { Header: 'Fax', accessor: 'fax' },
        { Header: 'Vervallen', accessor: 'expired' }
    ], []);
    const data = React.useMemo(() => creditures || [], [creditures]);
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({ columns, data });
    useEffect(() => {
        const newSortingCriteria = {
            sortColumnKey: defaultSortingCriteria.sortColumnKey,
            sortDirection: defaultSortingCriteria.sortDirection
        };
        setSortingCriteria(newSortingCriteria);
    }, []);
    const handleSort = (column) => {
        setSortingCriteria((prevSortingCriteria) => {
            const currentSortDirection = prevSortingCriteria?.sortDirection || 'asc';
            const sortDirection = column.id === prevSortingCriteria?.sortColumnKey ? (currentSortDirection === 'asc' ? 'desc' : 'asc') : 'asc';
            const newSortingCriteria = {
                sortColumnKey: column.id,
                sortDirection: sortDirection
            };
            onSorting(newSortingCriteria);
            return newSortingCriteria;
        });
    };
    const handleFilterChange = (columnId, value) => {
        setFilterValues((prevFilterValues) => {
            var updatedFilterValues = {
                ...prevFilterValues,
                [columnId]: value
            };
            if (typeof value === 'string' && value.length >= 2) {
                applyFilter(updatedFilterValues);
            }
            else if (value instanceof Date) {
                applyFilter(updatedFilterValues);
            }
            else if (typeof value != 'string' && typeof value != typeof Date) {
                applyFilter(updatedFilterValues);
            }
            if (typeof value === 'string' && value.length == 0) {
                const resetFilterValue = {
                    ...prevFilterValues,
                    [columnId]: null
                };
                updatedFilterValues = resetFilterValue;
                applyFilter(updatedFilterValues);
            }
            return updatedFilterValues;
        });
    };
    const applyFilter = (filterValues) => {
        onFilter(filterValues);
    };
    const clearFilters = () => {
        const nullFilterValues = Object.fromEntries(Object.keys(filterValues).map((key) => [key, null]));
        setFilterValues({});
        setShowFilters(!showFilters);
        onFilter(nullFilterValues);
    };
    const handleRowClick = (row) => {
        onRowClick(row.original.id);
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: 'd-flex justify-content-end mb-2 vn-filter-button-container', children: _jsx("div", { className: 'filter-header-container', children: _jsx(VnButton, { style: { borderRadius: '8px', minWidth: '41px', height: '37px', width: '20px' }, customClassName: !showFilters ? 'vn-header-buttons' : 'vn-header-buttons vn-table-filter-remove-button', icon: funnelOutline, customIconClassName: 'vn-filter-button-icon', mode: 'danger', onClick: () => {
                            !showFilters ? setShowFilters(!showFilters) : clearFilters();
                        } }) }) }), _jsx("div", { className: 'custom-table-container', children: _jsx("div", { className: 'vn-table-container', children: _jsx("div", { className: 'vn-main', children: _jsxs("table", { ...getTableProps(), className: 'table', children: [_jsx("thead", { className: 'vn-table-thead', children: headerGroups.map((headerGroup) => (_jsxs(React.Fragment, { children: [_jsx("tr", { ...headerGroup.getHeaderGroupProps(), className: 'vn-custom-grid-header-card', children: headerGroup.headers.map((column) => (_jsx("th", { ...column.getHeaderProps(), style: { cursor: 'pointer', padding: '16px' }, children: _jsxs("div", { onClick: () => handleSort(column), className: 'vn-grid-header-sort-inline header-caption', children: [column.render('Header'), sortingCriteria && sortingCriteria.sortColumnKey === column.id && (_jsx("span", { children: sortingCriteria.sortDirection === 'asc' ? (_jsx(IonIcon, { icon: arrowUp, className: 'ml-1 vn-grid-sorting-icon' })) : (_jsx(IonIcon, { icon: arrowDown, className: 'ml-1 vn-grid-sorting-icon' })) }))] }) }))) }), showFilters && (_jsx("tr", { children: headerGroup.headers.map((column) => (_jsx("td", { style: { borderBottomColor: '#80808047' }, children: column.id === 'preference' ? (_jsx("div", { style: { minHeight: '37px', marginLeft: '-6px' }, children: _jsx(Select, { menuPosition: 'fixed', isSearchable: false, styles: gridHeaderDropdownStyle, placeholder: 'Selecteer Status', value: creditorPrefernceDropdown?.find((option) => option.value === filterValues[column.id]), options: creditorPrefernceDropdown, onChange: (selectedOption) => handleFilterChange('preference', selectedOption ? selectedOption.value : undefined), isClearable: true }) })) : column.id === 'expired' ? (_jsx("div", { style: { minHeight: '37px', marginLeft: '-6px' }, children: _jsx(Select, { menuPosition: 'fixed', isSearchable: false, styles: gridHeaderDropdownStyle, placeholder: 'Selecteer Status', value: creditorExpiredDropdown?.find((option) => option.value === filterValues[column.id]), options: creditorExpiredDropdown, onChange: (selectedOption) => handleFilterChange('expired', selectedOption ? selectedOption.value : undefined), isClearable: true }) })) : (_jsx("div", { style: { width: '140px' }, children: _jsx("input", { className: 'form-control vn-Input', type: 'text', value: filterValues[column.id] || '', onChange: (e) => {
                                                                if (/^\d*$/.test(e.target.value) && column.id == 'creditorNumber') {
                                                                    handleFilterChange(column.id, e.target.value);
                                                                }
                                                                else if (column.id != 'creditorNumber') {
                                                                    handleFilterChange(column.id, e.target.value);
                                                                }
                                                            } }) })) }, column.id ? column.id : 0))) }))] }, headerGroup.id ? headerGroup.id : 0))) }), rows && data && (_jsx("tbody", { ...getTableBodyProps(), className: 'vn-table-tbody', children: rows.map((row) => {
                                        prepareRow(row);
                                        return (_jsx("tr", { ...row.getRowProps(), style: { cursor: 'pointer' }, onClick: () => handleRowClick(row), children: row.cells.map((cell, index) => (_createElement("td", { ...cell.getCellProps(), key: index ? index : 0, style: { padding: '4px' } }, cell.column.id === 'preference' ? (_jsxs("label", { className: `Vn-toggle-button-switch ${!handleRolePermission(Permission.LEVERANCIERS, PermissionType.Update)
                                                    ? 'disabled-toggles'
                                                    : ''}`, onClick: (e) => {
                                                    e.stopPropagation();
                                                }, children: [_jsx("input", { type: 'checkbox', checked: cell.value, onChange: (e) => onPreferenceToggleUpdate(row.original.id, e.target.checked), disabled: !handleRolePermission(Permission.LEVERANCIERS, PermissionType.Update) }, row.original.id), _jsx("span", { className: 'Vn-toggle-button-slider Vn-toggle-button-round' })] })) : cell.column.id === 'expired' ? (cell.value === true ? (_jsx("span", { children: "Ja" })) : (_jsx("span", { children: "Nee" }))) : (_jsx("span", { children: cell.render('Cell') }))))) }));
                                    }) }))] }) }) }) })] }));
};
export default InternalCreditureTable;
